"use strict";

import React from "react";
import Glyphicon from "../base/Glyphicon";

function LinkWarning(props) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        paddingLeft: 10,
        paddingRight: 10,
        paddingBottom: 10,
      }}
    >
      <div>
        <Glyphicon style={{ color: "#F9CE30" }} glyph="warning_sign" />
      </div>
      <div style={{ textAlign: "center" }}>
        Primary link set in 'Click Actions'. Embedded links will not work.
      </div>
    </div>
  );
}

export default LinkWarning;
